import React, { useContext, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
} from "@chakra-ui/react";

import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  id?: string;
  // handleGetWorkFlow: () => void;
  data?: any;
};

export default function SetDefaultModal({
  isOpen,
  onClose,
  id,
  // handleGetWorkFlow,
  data,
}: ModalProps): JSX.Element {
  const { toastNotify, getDefaultWorkFlow, getAccountDetails } = useContext(AppContext);
  const [defaultLoading, setDefaultLoading] = useState(false);

  const changeWorkFlowStatus = async (id: any, status: Boolean) => {
    try {
      setDefaultLoading(true);
      const response: any = await appRequest("workflow", "updateStatus", {
        id: id,
        status: status,
      });
      if (response.status === "success") {
        // handleGetWorkFlow();
        toastNotify({
          title: `Status updated successfully`,
          message: response?.message,
          type: "success",
        });
        getDefaultWorkFlow()
        getAccountDetails()
        onClose();
      } else {
        toastNotify({
          title: `Field to Update Status`,
          message: response?.message || "Something went wrong.",
          type: "error",
        });
      }
    } catch (err: any) {
      toastNotify({
        title: `Field to Update Status`,
        message: err?.message || "Something went wrong.",
        type: "error",
      });
    } finally {
      setDefaultLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody>
          {data?.defaultActive === false ? (
            <Text
              fontSize={{ base: "lg", md: "xl" }}
              fontWeight="500"
              color="red"
              mt={10}
              textAlign="center"
            >
              Are you sure you want to set this workflow as default?
            </Text>
          ) : (
            <Text
              fontSize={{ base: "lg", md: "xl" }}
              fontWeight="500"
              color="red"
              mt={10}
              textAlign="center"
            >
              Are you sure you want to set this workflow as default?
            </Text>
          )}
          <Text
            fontSize={{ base: "lg", md: "xl" }}
            fontWeight="700"
            color="red"
            mt={1}
            textAlign="center"
          >
            Please confirm?
          </Text>
        </ModalBody>

        <ModalFooter
          gap={6}
          mt={2}
          justifyItems="center"
          justifyContent="center"
          my={6}
        >
          <Button
            type="submit"
            w="70px"
            bg="teal.300"
            color="white"
            _hover={{
              bg: "teal.400",
            }}
            isLoading={defaultLoading}
            onClick={() => changeWorkFlowStatus(data._id, !data?.defaultActive)}
          >
            Yes
          </Button>
          <Button onClick={onClose} colorScheme="red" color="white" w="70px">
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
